import React from 'react'

const SkeletonTable = () => {
  const headerCount = 3
  const rowCount = 5

  return (
      <div className="container mx-auto px-4 py-4 overflow-auto">
        <h2 className="text-xl mb-2 w-full text-center font-bold">Prices</h2>
        <table className="min-w-full table-auto border-collapse">
          <thead>
          <tr>
            <th className="flex justify-center">
              <div className="w-24 h-12 bg-gray-300 animate-pulse rounded"></div>
            </th>
            {Array.from({ length: headerCount }).map((_, idx) => (
                <th
                    key={idx}
                    className="border border-gray-300 text-center"
                    colSpan={1}
                >
                  <div className="w-32 h-6 bg-gray-300 animate-pulse rounded mx-auto"></div>
                </th>
            ))}
          </tr>
          <tr>
            <th></th>
            {Array.from({ length: headerCount }).flatMap((_, idx) => (
                Array.from({ length: 1 }).map((__, subIdx) => (
                    <th key={`${idx}-${subIdx}`} className="px-4 py-2 border border-gray-300">
                      <div className="w-20 h-8 bg-gray-300 animate-pulse rounded mx-auto"></div>
                    </th>
                ))
            ))}
            <th></th>
          </tr>
          <tr>
            <th className="px-4 py-2 border border-gray-300 bg-gray-100">
              <div className="w-24 h-12 bg-gray-300 animate-pulse rounded mx-auto flex items-center justify-center"/>
            </th>
            {Array.from({length: headerCount}).flatMap((_, idx) => (
                Array.from({length: 1}).map((__, subIdx) => (
                    <th key={`${idx}-${subIdx}`} className="px-4 py-2 border border-gray-300 bg-gray-100 text-center">
                      <div className="w-6 h-6 bg-gray-300 animate-pulse rounded-md mx-auto"></div>
                    </th>
                ))
            ))}
            <th></th>
          </tr>
          </thead>
          <tbody>
          {Array.from({length: rowCount}).map((_, rowIdx) => (
              <tr key={rowIdx}>
                <td className="py-2 border border-gray-300">
                  <div className="w-20 h-12 bg-gray-300 animate-pulse rounded mx-auto"></div>
                </td>
                {Array.from({ length: headerCount }).flatMap((_, colIdx) => (
                    Array.from({ length: 1 }).map((__, subIdx) => (
                        <td key={`${rowIdx}-${colIdx}-${subIdx}`} className="px-4 py-2 border border-gray-300 text-center">
                          <div className="w-6 h-6 bg-gray-300 animate-pulse rounded-md mx-auto"></div>
                        </td>
                    ))
                ))}
              </tr>
          ))}
          </tbody>
        </table>
      </div>
  )
}

export default SkeletonTable
